import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "@features/DiscordAuth/api/authApiSlice";
import { baseApi } from "@shared/api/baseApi"; // Import the shared baseApi
// Remove unused imports for individual API slices if they are no longer needed elsewhere
// import { userInfoApi } from "@entities/User/api/UserInformationSlice";
import authReducer from "@features/DiscordAuth/model/authSlice";
import { gameModeSlice } from "@entities/Game/model/slice";
import { userInfoSlice } from "@entities/User/model/slice";
import { modalSlice } from "@widgets/ProfileModalPaiger/model/slice";
// import { betsApi } from "@entities/Bets/api/BetsApiSlice";
// import { leaderboardApi } from "@entities/LeaderBoard/api/LeaderBoardApi";
// import { productsApi } from "@entities/Shop/api/shopApiSlice";
import { shopSlice } from "@entities/Shop/model/shopSlice";
import { loadState } from "@shared/lib/LocalStorage/localStorage";
import { toastSlice } from "@features/toasts/toastSlice";
// import { casesApi } from "@entities/Case/CaseApi";

const initializeStore = () => {
  const savedTokens = loadState();
  
  const preloadedState = {
    auth: {
      tokens: savedTokens,
    },
  };

  return configureStore({
    reducer: {
      [authApi.reducerPath]: authApi.reducer, // Keep separate auth API
      [baseApi.reducerPath]: baseApi.reducer, // Add shared base API reducer
      // Remove individual API slice reducers as they are part of baseApi now
      auth: authReducer,
      gameMode: gameModeSlice.reducer,
      userInfo: userInfoSlice.reducer,
      modal: modalSlice.reducer,
      shop: shopSlice.reducer,
      toast: toastSlice.reducer,
    },
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["persist/PERSIST"],
          ignoredPaths: ["auth.tokens"],
        },
      })
        .concat(authApi.middleware) // Keep separate auth API middleware
        .concat(baseApi.middleware), // Add shared base API middleware
        // Remove individual API slice middlewares
  });
};

export const store = initializeStore();
export type AppStore = Awaited<ReturnType<typeof initializeStore>>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
